import { Typography } from '@material-ui/core'
import DownloadFile from '../../Services/DownloadFile'
import Download from '../../svgs/download'
import { useStyles } from './styles'
const DownloadForm = (props) => {
  const { PDFViewLink } = props
  const classes = useStyles()
  return (
    <div className={classes.layout}>
      <Download
        className={classes.downloadicon}
        onClick={() => {
          DownloadFile(PDFViewLink)
        }}
      ></Download>
      <Typography
        className={classes.downloadtext}
        onClick={() => {
          DownloadFile(PDFViewLink)
        }}
      >
        Download Application
      </Typography>
    </div>
  )
}
export default DownloadForm
